import React from "react";
import styled from "styled-components";

const FormButtonDanger = ({ children, size, ...props }) => {

  if (size === "extraSmall") {
    return (
      <ButtonDangerExtraSmall {...props}>
        {children}
      </ButtonDangerExtraSmall>
    );
  }

  if (size === "small") {
    return (
      <ButtonDangerSmall {...props}>
        {children}
      </ButtonDangerSmall>
    );
  }

  return (
    <ButtonDanger {...props}>
      {children}
    </ButtonDanger>
  );
};

const ButtonDanger = styled.button`
  flex-shrink: 0;
  padding: 11px 60px;
  background-color: var(--aia-bx-white);
  color: var(--aia-bx-black);
  border: 1px solid var(--aia-bx-red-1);
  border-radius: 100px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  visibility: visible;
  &:hover {
    background-color: var(--aia-bx-red-4);
  }
`;


const ButtonDangerSmall = styled.button`
  flex-shrink: 0;
  padding: 8px 30px;
  background-color: var(--aia-bx-white);
  color: var(--aia-bx-black);
  border: 1px solid var(--aia-bx-red-1);
  border-radius: 100px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  visibility: visible;
  &:hover {
    background-color: var(--aia-bx-red-4);
  }
`;

const ButtonDangerExtraSmall = styled.button`
  flex-shrink: 0;
  padding: 5px 20px;
  background-color: var(--aia-bx-white);
  color: var(--aia-bx-black);
  border: 1px solid var(--aia-bx-red-1);
  border-radius: 100px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  visibility: visible;
  &:hover {
    background-color: var(--aia-bx-aiaRed-10);
  }
`;


export default FormButtonDanger;